import React from "react";
import { useUserContext } from "context/UserContext";
import WarehousesBK from "layouts/BK/warehouses";
import WarehousesCM from "layouts/CM/warehouses";
import { isBkLikeRole } from "utils/roleUtils";

function Warehouses() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <WarehousesBK />;
  }
  if (role === "CM") {
    return <WarehousesCM />;
  }
  return null;
}

export default Warehouses;
